import axios from "axios";
import { LoginData, UserData } from "../../models/login/login.model";
import { OwnerData } from "../../models/ownerData/ownerData.model";
import { API_ENDPOINTS } from "../../../config/endpoints.config";

const loginPost = (loginData: LoginData): Promise<UserData> =>
  axios
    .post(API_ENDPOINTS.USER_LOGIN, loginData, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then(({ data }) => data)
    .catch(function (error) {
      throw error;
    });

const getOwnerData = async (
  loginData: LoginData | undefined,
  token: string
): Promise<OwnerData> =>
  axios
    .post(API_ENDPOINTS.USER_OWNERDATA, loginData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    })
    .then(({ data }) => {
      return data;
    })
    .catch(function (error) {
      throw error;
    });
export { loginPost, getOwnerData };
